import type { FaireProductEntity } from "../../entity_types/product";

export const p_wt988s75jd: FaireProductEntity = {
  token: "p_wt988s75jd",
  type: "product",
  name: "Making Memories With You Card",
  brandToken: "b_b7930ea2",
  brandName: "Small Adventure",
  imageUrl: "https://cdn.faire.com/fastly/a558e77280bc711d7513bcbcc5d0d4d80cdb1ef5a2394eefb3a6b8e934d140d8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/14dd4c780691a4f8057889d883a2ed49f1629f58c86b2065f9d9c0b8a3af015b.jpeg",
    "https://cdn.faire.com/fastly/b1700d1e06a0dab969c82a323293b4689cd3dfda80ac163e99e1593de4560a99.jpeg",
    "https://cdn.faire.com/fastly/1f3990f080878cec915396eb634e514f9b6bbcc3a032a2ef5865871671bb854e.jpeg"
  ],
  priceDollars: 3,
  description: "4.25 x 5.5 inch size\nComes with matching envelope\nPrinted in the USA on soft white, FSC-certified stock that is also milled in the USA\nBlank inside\nWraparound image",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:06:59.591Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
